import { useState } from "react"
import { useUpdateEffect } from "react-use"
import * as IDropdown from "../Dropdown"

type DropdownOwnProps = Readonly<{
  options: ReadonlyArray<string>
}>

export type InputGroupDropdownProps = DropdownOwnProps & React.ComponentPropsWithoutRef<typeof IDropdown.Root>

const Dropdown: React.FC<InputGroupDropdownProps> = ({
  placeholder,
  onValueSelect,
  options,
  ...dropdownProps
}: InputGroupDropdownProps) => {
  const [selectedValue, setSelectedValue] = useState<string | null>(null)

  useUpdateEffect(() => {
    if (selectedValue) {
      onValueSelect?.(selectedValue)
    }
  }, [selectedValue])

  return (
    <IDropdown.Root onValueSelect={(value: string) => setSelectedValue(value)} {...dropdownProps}>
      <IDropdown.Trigger>{selectedValue ?? placeholder ?? `Open`}</IDropdown.Trigger>
      <IDropdown.Content>
        {options.map((i) => (
          <IDropdown.Item value={i} key={i}>
            {i}
          </IDropdown.Item>
        ))}
      </IDropdown.Content>
    </IDropdown.Root>
  )
}

Dropdown.displayName = `InputGroup.Dropdown`

export { Dropdown }
